import {Directive, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';

@Directive({
    selector: '[reqClick]',
    host: {
        '(click)': '_onClick($event)'
    }
})

export class RequestButtonDirective {

    iconElement: any;
    oldIconClass: string;
    //MDK-Ver se da para tirar o texto
    //oldTextInner: string;

    @Input('animate') private animate: boolean = true;
    @Input('opacity') private opacity: boolean = true;
    @Output('reqClick') click: EventEmitter<any> = new EventEmitter();  // click somente se não estiver this._requesting

    constructor(public element: ElementRef, public renderer: Renderer2) {


    }

    ngOnInit() {

        this.renderer.addClass(this.element.nativeElement, 'request-button');

    }

    public _onClick(event) {

        if (this.animate) this.starteLoader(true);
        if (!this.animate) this.click.emit(this);

    }

    classeControl(): string {

        return (this.opacity ? 'request-button-opacity-sim' : 'request-button-opacity-nao');

    }

    starteLoader(click: boolean = false) {

        this.iconElement = this.element.nativeElement.querySelectorAll('span[class*=b-icon-]')[0];

        // impede que seja feita requisição enquanto outra está pendente
        if (this.element.nativeElement.className.indexOf(this.classeControl()) == -1) {

            this.renderer.addClass(this.element.nativeElement, this.classeControl());

            if (this.iconElement) {
                this.oldIconClass = this.iconElement.className;
                this.renderer.addClass(this.iconElement, 'b-icon-spinner');
                this.renderer.addClass(this.iconElement, 'animate-spin-fast');
                // da pra usar o Renderer2 para add class

                //MDK-Ver se da para tirar o texto
                //this.oldTextInner = this.element.nativeElement.innerText;
                //this.element.nativeElement.innerText = '';
            }

            if (click) this.click.emit(this);

        }

    }

    cancelLoader() {

        if (this.iconElement) {
            this.iconElement.className = this.oldIconClass;

            //MDK-Ver se da para tirar o texto
            //this.element.nativeElement.innerText = this.oldTextInner;
        }
        this.renderer.removeClass(this.element.nativeElement, this.classeControl());

    }

}



// WEBPACK FOOTER //
// ./src/directives/request-button.ts